import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import './Contents.css';

function Contents() {
    return (
            <Container className="text-white mt-5">
                <Row className="mt-3 mb-4">
                    <Col className="d-flex justify-content-center">
                    <h2>
                        Ausbildungsinhalte
                    </h2>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={4}>
                    <Card className="mb-4 card-equal-height" style={{backgroundColor: 'rgba(255, 255, 255, 0.07)', border: 'none'}}>
                    <Card.Img variant="top" src="./img/Contents/Techniken.jpg" className="card-img-fixed-height"/>
                    <Card.Body className="card-body" style={{color: '#efefef'}}>
                        <Card.Title className="text-danger">KRAV MAGA - Techniken & Praxis</Card.Title>
                        <Card.Text>
                        Bei uns vertiefst Du Dein <b>bestehendes</b> Krav Maga-Wissen und erweiterst 
                            es um alles Wesentliche, was für effektive Selbstverteidigung entscheidend ist.
                        </Card.Text>
                    </Card.Body>
                    </Card>
                    </Col>
                    <Col md={4}>
                    <Card className="mb-4 card-equal-height" style={{backgroundColor: 'rgba(255, 255, 255, 0.07)', border: 'none'}}>
                    <Card.Img variant="top" src="./img/Contents/Theorie.jpg" className="card-img-fixed-height" />
                    <Card.Body className="card-body" style={{color: '#efefef'}}>
                        <Card.Title className="text-danger">KRAV MAGA - Trainerpersönlichkeit</Card.Title>
                        <Card.Text>
                            Ein guter Trainer wird man nicht über Nacht. Nutze unsere 
                            langjährige Erfahrung in den Bereichen Sport, Pädagogik und Didaktik, 
                            um Dein volles Potenzial zu entfalten.
                        </Card.Text>
                    </Card.Body>
                    </Card>
                    </Col>
                    <Col md={4}>
                    <Card className="mb-4 card-equal-height" style={{backgroundColor: 'rgba(255, 255, 255, 0.07)', border: 'none'}}>
                    <Card.Img variant="top" src="./img/Contents/Trainingskonzept.jpg" className="card-img-fixed-height" />
                    <Card.Body className="card-body" style={{color: '#efefef'}}>
                        <Card.Title className="text-danger">KRAV MAGA - Trainingskonzepte</Card.Title>
                        <Card.Text>
                            Lerne mit uns, das Beste aus Deiner Trainingsgruppen herauszuholen. 
                            Gemeinsam entwickeln wir ein Trainingskonzept, 
                            das Deine Teilnehmenden begeistert und nachhaltig motiviert.
                        </Card.Text>
                    </Card.Body>
                    </Card>
                    </Col>
                </Row>
            
            </Container>
            );
}

export default Contents;
